// Compatibility for existing bookmarks and GitHub App setup URLs: GitHub is one of Settings › Connections › Apps.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute('/_settings/settings/github')({
  validateSearch: z.object({ github: z.enum(['connected', 'denied', 'failed']).optional().catch(undefined) }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings/apps', search: { app: 'github', github: search.github }, replace: true });
  },
});
